
    // Simple 2D Point structure since we don't need the complexity of Phaser.Point

    export class MyPoint {
      
        public x: number; 
        public y: number; 

        constructor(new_x: number, new_y: number) {
            this.set(new_x, new_y); 
        }

        public set(new_x: number, new_y: number) {
            this.x = new_x; 
            this.y = new_y;
        }


    }

